(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('dataservice', dataservice);

    dataservice.$inject = ['$http', '$q', 'exception', 'logger'];
    /* @ngInject */
    function dataservice($http, $q, exception, logger) {
        var service = {
            getItem: getItem,
            getItems: getItems,
            saveItem: saveItem,
            deleteItem: deleteItem,
            putItem: putItem,
            query: query,
            getCounts: getCounts,
            postFile: postFile
        };

        return service;

        
        function query(path, dto) {
            return $http.post(path, dto)
                .then(success).catch(fail);

            function success(response) {
                logger.info("Query successful: ");
                return response;
            }

            function fail(e) {
                return exception.catcher('Error querying for items')(e);
            }
        }

        function postFile(path, file, dto, fileName) {

            var fd = new FormData();
            fd.append('file', file, fileName);
            if (dto) {
                for (var p in dto) {
                    if (dto.hasOwnProperty(p)) {
                        fd.append(p, dto[p]);
                    }
                }
            }
            var config = {
                headers: { "Content-Type": undefined },
                transformRequest: angular.identity
            };
            return $http.post(path, fd, config).catch(fail);

            function fail(e) {
                return exception.catcher('Error saving item')(e);
            }
        }

        function saveItem(path, dto, suppressSuccessMsg, msg, suppressErrorMsg) {
            return $http.post(path, dto)
                .then(success).catch(fail);

            function success(response) {
                if (!suppressSuccessMsg) {
                    logger.success(msg || "Item saved");
                }
                return response;
            }

            function fail(e) {
                return exception.catcher('Error saving item', suppressErrorMsg)(e);
            }
        }

        function putItem(path) {
            return $http.put(path)
                .then(success).catch(fail);

            function success(response) {
                logger.success("Item saved")
                return response;
            }

            function fail(e) {
                return exception.catcher('Error saving item')(e);
            }
        }

        function getItem(path, successMsg, failureMsg) {
            return $http.get(path)
                .then(success).catch(fail);

            function success(response) {
                logger.info(successMsg || "Item acquired")
                return response;
            }

            function fail(e) {
                return exception.catcher(failureMsg || 'Error getting item')(e);
            }
        }

        function deleteItem(path, suppressSuccess) {
            return $http.delete(path)
                .then(success).catch(fail);

            function success(response) {
                if (!suppressSuccess) {
                    logger.success("Item deleted")
                }
                return response;
            }

            function fail(e) {
                return exception.catcher('Error deleting item')(e);
            }
        }

        function getItems(path, successMsg, failureMsg) {
            return $http.get(path)
                .then(success).catch(fail);

            function success(response) {
                logger.info(successMsg || "Items acquired successfully")
                return response;
            }

            function fail(e) {
                return exception.catcher(failureMsg || "Error acquiring items")(e);
            }
        }

        function getCounts(m) {
            var t = new Date();
            var d = m.toDate();
            var q = moment(new Date(d.getFullYear(), d.getMonth(), d.getDate(), t.getHours(), t.getMinutes(), 0, 0));

            return $http.get('api/Counts/ForDashboard?localDate=' + q.toISOString() + "&localIsoDateOnly=" + q.format("YYYY-MM-DD"))
                .then(success).catch(fail);

            function success(response) {
                return response;
            }

            function fail(e) {
                return exception.catcher("Error getting counts")(e);
            }
        }
        

    }
})();
